module.exports = __webpack_public_path__ + "img/linksIndicatorInactive.70d50ae7.png";